










































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import {
  loading,
  loadingCatch,
  pagination,
  SearchbarControl
} from "@root/lib/decorator";

const Root = namespace("root");
@Component({})
@SearchbarControl()
@pagination("getData", {
  pageSize: 50
})
export default class EmportCompontet extends Vue {
  @Prop({ type: String, default: "" }) pageTitle;
  @Prop({ type: String, default: "" }) exportNotice;
  @Prop({ type: Array, required: true }) tabOptions;
  @Prop({ type: String }) tipContent;
  @Prop({ type: Function }) exportFn;
  @Prop({ type: String, default: "" }) loadingNotice;

  @Root.Action exportProductExcel;
  @Root.Action downLoadExcelFile;
  @Root.Action queryExportFile;
  @Root.Action queryExcelExportFile;
  @Root.Action grantExportFileAccessUrl;
  @Root.Action ddCodes;

  activeName = "";
  hitoryList = [];
  loading = false;
  category = "";
  total = 0;
  showNotice = false;
  timer = null;
  tag: any = {
    tagType: "success",
    name: "Success"
  };
  refreshLoading = false;

  async created() {
    await this.pageInit();
  }
  get exportPriceParams() {
    return "pim.product";
  }
  get unPriceExport() {
    // 有参数就是非商品管理的金额，因为，只有商品管理用的是单独一个接口
    return this.activeName !== "1";
  }

  get currentActiveName() {
    return this.fActiveLabel(this.activeName);
  }
  async pageInit() {
    // set default active name
    const { exportParams } = this.$route.query;
    this.activeName = exportParams ? String(exportParams) : "";
    await this.getData();
  }
  async onTabSwitch({ index }) {
    (this as any).handlePageChange(1);
  }

  // 导出商品
  async exportProduct() {
    this.$$prompt
      .call(this, {
        title: this.$t("Root.Export.export_all"),
        message: this.$t("Root.Export.export_all_notice"),
        confirmButtonText: this.$t("Root.Export.export")
      })
      .then(async () => {
        this.showExportNotice();
        if (!this.exportFn) {
          let res = await this.exportProductExcel({
            orgCode: localStorage.getItem("org") || "default"
          });
        } else {
          await this.exportFn(this.category);
        }
        (this as any).handlePageChange(1);
      })
      .catch(error => {
        console.log(error);
      });
  }

  showExportNotice() {
    this.showNotice = true;
    clearTimeout(this.timer);
    setTimeout(() => {
      this.showNotice = false;
    }, 2000);
  }
  // 下载文件
  async downloadProduct(row) {
    let res;
    const { type = "" } = row;
    // type 1表示价格列表
    if (type !== "1") {
      res = await this.downLoadExcelFile({ id: row.id });
    } else {
      res = await this.grantExportFileAccessUrl({ exportNo: row.exportNo });
    }
    this.createDownA(res);
  }
  createDownA(url) {
    let eleLink = document.createElement("a");
    eleLink.download = url;
    eleLink.style.display = "none";
    eleLink.href = url;
    document.body.appendChild(eleLink);
    eleLink.click();
    document.body.removeChild(eleLink);
  }
  // 刷新历史记录
  async refreshHistory() {
    this.refreshLoading = true;
    await this.getData();
    this.refreshLoading = false;
  }
  // 获取导出历史记录列表
  @loadingCatch
  async getData() {
    console.log("get-data");
    // 这里设置type表示获取数据类型不一样
    const { pageSize, currentPage: pageNum, activeName }: any = this;
    let input = {
      fileRecordVo: {},
      pageInput: {
        pageNum,
        pageSize
      }
    };
    input["fileRecordVo"]["exportType"] = activeName || null;
    this.loading = true;
    // 商品价格导出特定,写死
    // FIXME: 没有商品价格的导出了
    const queryPrice = async () => {
      let { list, total } = await this.queryExportFile({
        condition: {
          category: this.exportPriceParams
        },
        pageInput: {
          pageNum,
          pageSize
        }
      });
      list = list.map(el => ({
        createName: el && el.createUser,
        type: "1",
        exportType: "1",
        exportResult: "1",
        ...el
      }));
      return {
        list,
        total
      };
    };
    if (this.unPriceExport) {
      let { list, total } = await this.queryExcelExportFile({
        ...input
      });
      // 全部选项的时候
      // if (!this.activeName) {
      //   let { list: priceList, total: priceTotal } = await queryPrice();
      //   list = priceList.concat(list);
      //   total = priceTotal + total;
      // }
      this.loading = false;
      this.hitoryList = list;
      this.total = total;
    } else {
      const { list, total } = await queryPrice();
      this.loading = false;
      this.hitoryList = list;
      this.total = total;
    }
  }

  statusToType(type) {
    const key = type && type.toLocaleUpperCase();
    const map = {
      FINISHED: "success",
      FAILED: "danger",
      PROCESSING: "warning"
    };
    return map[key] || "danger";
  }
  handleStatusText(status) {
    if (this.$i18n.locale === "zh-cn") {
      const languageMap = {
        FINISHED: "成功",
        FAILED: "失败",
        PROCESSING: "进行中"
      };
      return languageMap[status] || languageMap["PROCESSING"];
    } else {
      return status;
    }
  }

  fActiveLabel(val) {
    const obj = this.tabOptions.find(el => el && el.value === val);
    return obj && obj.label;
  }
  onReset() {
    this.activeName = "";
    this.getData();
  }
  onSearchBtnClick() {
    console.log("0000 search");
    this.getData();
  }
}
